import { BaseVisual } from "../../../visuals/BaseVisual";
import { C4Visual } from "../../../visuals/C4Visual";
import { BaseAgent } from "./BaseAgent";
import { C4Container } from "./c4/C4Container";
import { Interceptor } from "./c4/Interceptor";

export class C4Agent extends BaseAgent {
  c4: C4Visual;
  container?: C4Container;
  interceptors: Interceptor[] = [];
  constructor(visual: C4Visual) {
    super(visual);
    this.c4 = visual;
    this.addState('Container on', async () => {
      this.container = new C4Container(this.visual.wr);
      this.visual.obj.add(this.container.obj);
      return true;
    }, async () => {
      console.log('C4 container off');  
      this.container?.obj.removeFromParent();
    });
    this.enableState('Container on');
    // const target = this.visual.wr.dataService.findVisual('Shahed') as BaseVisual;
    // if (target) {
    //   setTimeout(() => {
    //     this.fire(target, () => {
    //       console.log('Target destroyed');
    //     });
    //   }, 3000);
    // } else {
    //   console.log('No target found for C4Agent to fire at');
    // }
  }

  public fire(target: BaseVisual, onDestroy:(t: BaseVisual) => void = () => {}) {
    const interceptor = new Interceptor(target, this, onDestroy);
    this.interceptors.push(interceptor);
    interceptor.intercept(target);
  }

  public async setup() {
    // this.c4 = this.visual.wr.dataService.findVisualsByType('C4Visual')[0] as C4Visual;
    // console.log({ c4: this.c4 });
  }

  public async loop(): Promise<void> {
    // if (this.c4) {
    //   // console.log('C4Agent loop', this.c4.obj.position);
    // }
  }

  public render(delta: number): boolean {
    for (const interceptor of this.interceptors) {
      interceptor.render(delta);
      if (!interceptor.active) {
        this.interceptors = this.interceptors.filter(i => i !== interceptor);
      }
    }
    return false;
  }
}